import setupTooltips from "./tooltip";
import setupMap from "./map";

document.addEventListener("DOMContentLoaded", function () {
  const buildings = document.querySelectorAll(".building");
  const svgMap = document.getElementById("parentSvg");
  setupTooltips(buildings);
  setupMap(svgMap);
});
